import { useEffect, useState } from 'react';
import { OverlayTrigger, Popover, PopoverContent } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { companyLogin } from '../../api/authentication';
import { Input, Password } from '../Input/Input';

const LoginForm = ({
  handleUserLoginSuccess,
  setDisplayMFAForm,
  userLockedOut,
  accessCodeErrorMessage,
  showContactITSupportLink,
  setShowContactITSupportLink,
}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [linkWording, setLinkWording] = useState('Forgotten your password?');
  const [errorMessage, setErrorMessage] = useState('');
  const [disableSubmitFormButton, setDisableSubmitFormButton] = useState(false);

  useEffect(() => {
    if (userLockedOut) {
      setErrorMessage('Account locked');
      setLinkWording('reset password');
      setDisableSubmitFormButton(userLockedOut);
    }
  }, [userLockedOut]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const data = await companyLogin(event.target);

      if (data.success === true) {
        const isMFAEnable = data.mfaEnable;
        if (isMFAEnable) {
          //new functionality for CABS-1939 - if the user verified recently then we can bypass the access verification step
          const otpVerified = data.otpVerified;
          if (otpVerified) {
            handleUserLoginSuccess(data);
          } else {
            //set the username as a session storage so we can use it on the multi factor authentication page
            setDisplayMFAForm(true);
            sessionStorage.setItem('token', data.token);
          }
        } else {
          handleUserLoginSuccess(data);
        }
      } else if (data.expired === true) {
        setErrorMessage('Password expired');
        setShowContactITSupportLink(true);
        setLinkWording('reset password');
        //the user will not be able to login, so disable the form button ('Login')
        setDisableSubmitFormButton(data?.lockedout);
      } else {
        setErrorMessage(data.err);
        setShowContactITSupportLink(data.err === 'Account locked');
        //the user will not be able to login, so disable the form button ('Login');
        setLinkWording('reset password');
        setDisableSubmitFormButton(data?.lockedout);
      }
    } catch (err) {
      console.error(err);
      setShowContactITSupportLink(false);
      setErrorMessage('Server error.');
    }
  };

  return (
    <div className="full-width-container">
      <div className="floating-box login-container">
        <h1 className="floating-box-header">Sign In</h1>
        <form onSubmit={handleSubmit} className="d-flex flex-column p-3">
          <Input
            name="username"
            type="text"
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Password name="password" label="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <span className="text-danger">
            {errorMessage && (
              <>
                {<span style={{ textTransform: 'capitalize' }}>{errorMessage}</span>}
                {showContactITSupportLink && ':'}{' '}
                {showContactITSupportLink && (
                  <>
                    Please <Link to="/forgotPassword">{linkWording}</Link>
                  </>
                )}
              </>
            )}
            &nbsp;
          </span>
          <div className="d-flex flex-row justify-content-between align-items-center my-2">
            <button
              style={{ height: '52px', margin: '0' }}
              className="blue-button mx-0"
              disabled={disableSubmitFormButton}
            >
              Login
            </button>
            <div className="d-flex flex-column justify-content-between">
              <Link to="/forgotPassword">Forgotten your password?</Link>
              <OverlayTrigger
                placement="auto"
                trigger={['click']}
                rootClose
                overlay={
                  <Popover style={{ minWidth: '35rem' }}>
                    <PopoverContent>
                      <h6>More info</h6>
                      <p>
                        If you are having trouble logging in please contact us below
                        <div className="bold text-eoriblue text-nowrap ms-2 mt-1">P: +44 (0) 333 012 4819</div>
                        <div className="bold text-eoriblue ms-2">
                          E:{' '}
                          <a className="bold text-eoriblue" href="mailto:cabiesupport@eori.uk?subject=CABIE Issue">
                            CABIEsupport@eori.uk
                          </a>
                        </div>
                      </p>
                    </PopoverContent>
                  </Popover>
                }
              >
                <div className="more-help">Need more help?</div>
              </OverlayTrigger>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
